export const HOME = { emergentLink: "home-emergent-link" };

export const NAV = {
  logo: "nav-logo",
  linkServices: "nav-link-services",
  linkAbout: "nav-link-about",
  linkPortfolio: "nav-link-portfolio",
  linkContact: "nav-link-contact",
  cta: "nav-cta",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  ctaStart: "hero-cta-start",
  ctaExplore: "hero-cta-explore",
  scrollIndicator: "hero-scroll-indicator",
};

export const CONTACT = {
  form: "contact-form",
  name: "contact-name",
  email: "contact-email",
  phone: "contact-phone",
  service: "contact-service",
  message: "contact-message",
  submit: "contact-submit",
};

export const ADMIN = {
  loginForm: "admin-login-form",
  loginEmail: "admin-login-email",
  loginPassword: "admin-login-password",
  loginSubmit: "admin-login-submit",
  dashboard: "admin-dashboard",
  logoutBtn: "admin-logout",
  leadRow: "admin-lead-row",
};
